import ToolbarFontFamilyMenuTemplate from './toolbar-font-family-menu.component.html';

class ToolbarFontFamilyMenuController {
  /**
   * @ngInject
   */

  select(font) {
    this.onSelect({ font });
  }
}

export default {
  bindings: {
    fonts: '<',
    menuType: '@',
    onSelect: '&',
    chosenFont: '<',
  },
  template: ToolbarFontFamilyMenuTemplate,
  controller: ToolbarFontFamilyMenuController,
  controllerAs: 'ctrl',
};
